/**
 * Somali shilling.
 */
export var SOS = {
  code: 'SOS',
  base: 10,
  exponent: 2
};